import { Injectable, signal, Type } from '@angular/core';
import { Drawer } from '../components/drawer/drawer';
import { DrawerRef } from '../components/drawer/drawer-ref';

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  private wrapper!: Drawer;
  drawerClosed = signal<boolean>(true)

  register(wrapper: Drawer) {
    this.wrapper = wrapper;
  }

  open<T>(
    component: Type<any>,
    data?: any,
    config?: { width?: string; position?: 'left' | 'right'; showHeader?: boolean, header?: string | undefined; customClass?: string;closable?:boolean }
  ): DrawerRef<T> {
    this.drawerClosed.set(false);
    return this.wrapper.open(component, data, config);
  }

  close(result?: unknown) {
    this.wrapper.onClose();
    this.drawerClosed.set(true)
  }
}